var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row banner_area text-center"},_vm._l((_vm.banners),function(banner,i){return _c('div',{key:i,staticClass:"col-lg-6 mb-5"},[_c('a',{attrs:{"href":banner.acf.url}},[_c('img',{attrs:{"src":banner.better_featured_image.source_url,"alt":""}})])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }